import React, { useEffect, useState, Fragment } from "react";

import styled from "styled-components";
import { useAlert, useGroupPosition } from "src/hooks";
import { useRecoilState } from "recoil";
import { recoilStates } from "src/recoil/recoilStates";
import { useNavigate } from "react-router-dom";
import { TeamSubmitDataType } from "src/types";
import { usePopupSelectV2 } from "../PopupSelect";

// 조 추가 모달 컴포넌트
const AddJoModal = ({
  isOpen,
  onClose,
  onAddTeams,
}: {
  isOpen: boolean;
  onClose: () => void;
  onAddTeams: (count: number) => void;
}) => {
  const [selectedOption, setSelectedOption] = useState("5");

  const handleOptionSelect = (value: string) => {
    setSelectedOption(value);
  };

  const handleCancel = () => {
    onClose();
  };

  const handleSelect = () => {
    onAddTeams(parseInt(selectedOption));
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="addjo-page">
      <div className="addjo-modal">
        <div className="addjo-modal-container">
          <div className="addjo-modal-content">
            <h1 className="addjo-modal-title">조 추가</h1>

            <div className="addjo-options-container">
              <div
                className={`addjo-option-button ${selectedOption === "5" ? "active" : "default"}`}
                onClick={() => handleOptionSelect("5")}
              >
                <div className="addjo-option-content">
                  <div className="addjo-option-left">
                    <div className="check-circle-wrapper">
                      <div className="check-circle-background"></div>
                      <svg
                        className={`check-circle-icon ${selectedOption === "5" ? "active" : ""}`}
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M7.83317 12.8334L13.7082 6.95842L12.5415 5.79175L7.83317 10.5001L5.45817 8.12508L4.2915 9.29175L7.83317 12.8334ZM8.99984 17.3334C7.84706 17.3334 6.76373 17.1147 5.74984 16.6772C4.73595 16.2397 3.854 15.6459 3.104 14.8959C2.354 14.1459 1.76025 13.264 1.32275 12.2501C0.885254 11.2362 0.666504 10.1529 0.666504 9.00008C0.666504 7.8473 0.885254 6.76397 1.32275 5.75008C1.76025 4.73619 2.354 3.85425 3.104 3.10425C3.854 2.35425 4.73595 1.7605 5.74984 1.323C6.76373 0.885498 7.84706 0.666748 8.99984 0.666748C10.1526 0.666748 11.2359 0.885498 12.2498 1.323C13.2637 1.7605 14.1457 2.35425 14.8957 3.10425C15.6457 3.85425 16.2394 4.73619 16.6769 5.75008C17.1144 6.76397 17.3332 7.8473 17.3332 9.00008C17.3332 10.1529 17.1144 11.2362 16.6769 12.2501C16.2394 13.264 15.6457 14.1459 14.8957 14.8959C14.1457 15.6459 13.2637 16.2397 12.2498 16.6772C11.2359 17.1147 10.1526 17.3334 8.99984 17.3334Z"
                          fill={selectedOption === "5" ? "#007BFF" : "#D1D5D8"}
                        />
                      </svg>
                    </div>
                    <span className="addjo-option-text">5개 조 추가</span>
                  </div>
                </div>
              </div>

              <div
                className={`addjo-option-button ${selectedOption === "10" ? "active" : "default"}`}
                onClick={() => handleOptionSelect("10")}
              >
                <div className="addjo-option-content">
                  <div className="addjo-option-left">
                    <div className="check-circle-wrapper">
                      <div className="check-circle-background"></div>
                      <svg
                        className={`check-circle-icon ${selectedOption === "10" ? "active" : ""}`}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M6.81745 11.5447L12.42 5.94221L11.5418 5.06409L6.81745 9.78846L4.44245 7.41346L3.56433 8.29158L6.81745 11.5447ZM8.00162 15.9166C6.90662 15.9166 5.87738 15.7088 4.91391 15.2933C3.95044 14.8777 3.11238 14.3137 2.39975 13.6014C1.68711 12.889 1.12287 12.0513 0.707038 11.0883C0.291343 10.1252 0.0834961 9.09624 0.0834961 8.00138C0.0834961 6.90638 0.291274 5.87714 0.706829 4.91367C1.12238 3.9502 1.68634 3.11214 2.3987 2.3995C3.11107 1.68686 3.94877 1.12263 4.91183 0.706793C5.87489 0.291099 6.90384 0.083252 7.9987 0.083252C9.0937 0.083252 10.1229 0.291029 11.0864 0.706585C12.0499 1.12214 12.8879 1.6861 13.6006 2.39846C14.3132 3.11082 14.8775 3.94853 15.2933 4.91159C15.709 5.87464 15.9168 6.9036 15.9168 7.99846C15.9168 9.09346 15.7091 10.1227 15.2935 11.0862C14.8779 12.0496 14.314 12.8877 13.6016 13.6003C12.8893 14.313 12.0516 14.8772 11.0885 15.293C10.1254 15.7087 9.09648 15.9166 8.00162 15.9166ZM8.00016 14.6666C9.86127 14.6666 11.4377 14.0208 12.7293 12.7291C14.021 11.4374 14.6668 9.86103 14.6668 7.99992C14.6668 6.13881 14.021 4.56242 12.7293 3.27075C11.4377 1.97909 9.86127 1.33325 8.00016 1.33325C6.13905 1.33325 4.56266 1.97909 3.271 3.27075C1.97933 4.56242 1.3335 6.13881 1.3335 7.99992C1.3335 9.86103 1.97933 11.4374 3.271 12.7291C4.56266 14.0208 6.13905 14.6666 8.00016 14.6666Z"
                          fill={selectedOption === "10" ? "#007BFF" : "#D1D5D8"}
                        />
                      </svg>
                    </div>
                    <span className="addjo-option-text">10개 조 추가</span>
                  </div>
                </div>
              </div>

              <div
                className={`addjo-option-button ${selectedOption === "15" ? "active" : "default"}`}
                onClick={() => handleOptionSelect("15")}
              >
                <div className="addjo-option-content">
                  <div className="addjo-option-left">
                    <div className="check-circle-wrapper">
                      <div className="check-circle-background"></div>
                      <svg
                        className={`check-circle-icon ${selectedOption === "15" ? "active" : ""}`}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M6.81745 11.5447L12.42 5.94221L11.5418 5.06409L6.81745 9.78846L4.44245 7.41346L3.56433 8.29158L6.81745 11.5447ZM8.00162 15.9166C6.90662 15.9166 5.87738 15.7088 4.91391 15.2933C3.95044 14.8777 3.11238 14.3137 2.39975 13.6014C1.68711 12.889 1.12287 12.0513 0.707038 11.0883C0.291343 10.1252 0.0834961 9.09624 0.0834961 8.00138C0.0834961 6.90638 0.291274 5.87714 0.706829 4.91367C1.12238 3.9502 1.68634 3.11214 2.3987 2.3995C3.11107 1.68686 3.94877 1.12263 4.91183 0.706793C5.87489 0.291099 6.90384 0.083252 7.9987 0.083252C9.0937 0.083252 10.1229 0.291029 11.0864 0.706585C12.0499 1.12214 12.8879 1.6861 13.6006 2.39846C14.3132 3.11082 14.8775 3.94853 15.2933 4.91159C15.709 5.87464 15.9168 6.9036 15.9168 7.99846C15.9168 9.09346 15.7091 10.1227 15.2935 11.0862C14.8779 12.0496 14.314 12.8877 13.6016 13.6003C12.8893 14.313 12.0516 14.8772 11.0885 15.293C10.1254 15.7087 9.09648 15.9166 8.00162 15.9166ZM8.00016 14.6666C9.86127 14.6666 11.4377 14.0208 12.7293 12.7291C14.021 11.4374 14.6668 9.86103 14.6668 7.99992C14.6668 6.13881 14.021 4.56242 12.7293 3.27075C11.4377 1.97909 9.86127 1.33325 8.00016 1.33325C6.13905 1.33325 4.56266 1.97909 3.271 3.27075C1.97933 4.56242 1.3335 6.13881 1.3335 7.99992C1.3335 9.86103 1.97933 11.4374 3.271 12.7291C4.56266 14.0208 6.13905 14.6666 8.00016 14.6666Z"
                          fill={selectedOption === "15" ? "#007BFF" : "#D1D5D8"}
                        />
                      </svg>
                    </div>
                    <span className="addjo-option-text">15개 조 추가</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="addjo-modal-buttons">
          <button className="addjo-cancel-button" onClick={handleCancel}>
            취소
          </button>
          <button className="addjo-select-button" onClick={handleSelect}>
            선택하기
          </button>
        </div>
      </div>
    </div>
  );
};

const TeamSelector = (props: {
  teams: TeamSubmitDataType;
  memberId: number;
  setTeams: React.Dispatch<React.SetStateAction<TeamSubmitDataType | undefined>>;
  openJoModal: (memberId: number) => void;
}) => {
  const rowTeam = props.teams.find((t) => t.members.some((m) => m.member_id === props.memberId));
  return (
    <div className="team-selector-wrapper">
      <button
        type="button"
        className="popup-select-result"
        onClick={() => props.openJoModal(props.memberId)}
      >
        {rowTeam?.team_number ? `${rowTeam.team_number}조` : "-조"}
        <svg className="dropdown-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none">
          <path
            d="M1 1L6 6L11 1"
            stroke="#007BFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

const AddTeamCountObjArr = [
  { id: 5, name: "5개 조 추가" },
  { id: 10, name: "10개 조 추가" },
  { id: 15, name: "15개 조 추가" },
];

export default function MemberSearchPopupContents(props: {
  closeMe: () => void;
  setTeams: React.Dispatch<React.SetStateAction<TeamSubmitDataType | undefined>>;
  teams: TeamSubmitDataType;
  handleSubmit: any;
  isFixed?: boolean;
  selectedDate?: string;
  maxTeams?: number;
  onAddTeams?: (count: number) => void;
}) {
  const [group] = useRecoilState(recoilStates.group);
  const positions = useGroupPosition();
  console.log("group.members :", group.members);
  const [bookingApplication] = useRecoilState(recoilStates.bookingApplication);

  const [memberData, setMemberData] = useState([...(group?.members || [])]);
  const [isAddJoModalOpen, setIsAddJoModalOpen] = useState(false);
  const [isJoModalOpen, setIsJoModalOpen] = useState(false);
  const [joTargetMemberId, setJoTargetMemberId] = useState<number | null>(null);

  const alert = useAlert();

  const {
    PopupSelect: TeamAddSelect,
    propsToInject: teamAddingPropsToInject,
    reset: resetTeasmAddingSelectState,
  } = usePopupSelectV2();

  useEffect(() => {
    if (!props?.teams?.length) {
      return;
    }
    setMemberData((prev) => {
      prev?.sort((a, b) => {
        const teamNumberA =
          props.teams.find((t) => t.members.find((m) => m.member_id === a.id))?.team_number ||
          99999;
        const teamNumberB =
          props.teams.find((t) => t.members.find((m) => m.member_id === b.id))?.team_number ||
          99999;

        return teamNumberA - teamNumberB;
      });
      return [...(prev || [])];
    });
  }, [props.teams]);

  const navigate = useNavigate();

  const openJoModal = (memberId: number) => {
    setJoTargetMemberId(memberId);
    setIsJoModalOpen(true);
  };

  const handleSelectTeamNumber = (teamNumber: number) => {
    if (!joTargetMemberId) return;
    props.setTeams((prev) => {
      const next = [...(prev || [])];
      const currentTeam = next.find((t) => t.members.some((m) => m.member_id === joTargetMemberId));
      const targetTeam = next.find((t) => t.team_number === teamNumber);
      if (!targetTeam) return next;
      if (targetTeam.members?.length === 4) {
        alert("팀당 인원은 최대 4명까지 입니다.");
        return next;
      }
      if (currentTeam) {
        currentTeam.members = currentTeam.members.filter((m) => m.member_id !== joTargetMemberId);
      }
      targetTeam.members.push({ member_id: joTargetMemberId });
      return next;
    });
    setIsJoModalOpen(false);
    setJoTargetMemberId(null);
  };

  const handleAddTeams = (count: number) => {
    if (props.onAddTeams) {
      props.onAddTeams(count);
    } else {
      // 기존 로직 (fallback)
      props.setTeams((prev) => {
        if (!prev) {
          return [...(prev || [])];
        }

        prev.sort((a, b) => a.team_number - b.team_number);
        const lastTeamNumber = prev[prev.length - 1]?.team_number;

        for (let i = 1; i <= count; i++) {
          prev.push({ team_number: lastTeamNumber + i, members: [] });
        }

        return [...(prev || [])];
      });
    }
  };

  return (
    <Fragment>
      <Container className="time-page-container">
        {/* Info Notice */}
        <div className="info-notice">
          <p className="notice-text">
            라운드 3일 전까지 라운드 일자별 조를 편성해 제출해주세요.
            <br />
            한번 제출된 조편성은 변경이 어려우니 신중을 기해주세요.
          </p>
        </div>

        {/* Round Date Section */}
        <div className="round-date-section">
          <label className="section-label">라운드 일자</label>
          <div className="date-selector">
            <span className="selected-date">{props.selectedDate || "날짜를 선택하세요"}</span>
          </div>
        </div>

        <div className="section-divider"></div>

        {/* Team Formation Section */}
        <div className="team-formation-section">
          <div className="section-header">
            <h2 className="section-title">조편성</h2>
            <span className="member-count">
              멤버 수 <strong>{group.members?.length || 0}명</strong>
            </span>
          </div>

          <div className="team-list">
            {memberData.map((member, index) => {
              const assignedTeam = props.teams?.find((t) =>
                t.members.some((tm) => tm.member_id === member.id)
              );

              return (
                <div key={member.id} className="team-card">
                  <div className="team-content">
                    <div className="team-number">
                      {!props.isFixed ? (
                        <TeamSelector
                          teams={props.teams}
                          memberId={member.id}
                          setTeams={props.setTeams}
                          openJoModal={openJoModal}
                        />
                      ) : (
                        <span className="group-text">
                          {assignedTeam ? `${assignedTeam.team_number}조` : "-"}
                        </span>
                      )}
                    </div>
                    <div className="member-info">
                      <span className="member-role">
                        {positions?.find((p) => p.id === member.booking_group_member_level_id)
                          ?.name || "일반"}
                      </span>
                      <span className="member-name">{member.name}</span>
                      <span className="member-phone">{member.phone_number}</span>
                      <span className="member-type">{props.isFixed ? "확정" : ""}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Fixed Bottom Button */}
        <div className="fixed-bottom-container">
          <div className="action-buttons">
            {/* <button
          className="edit-button"
          onClick={() => {
            if (!props.isFixed) {
              setIsAddJoModalOpen(true);
            }
          }}
        >
          조 추가
        </button> */}
            <button
              className="cta-button"
              disabled={props.isFixed}
              onClick={async () => {
                await props.handleSubmit(true);
                navigate("/year-booking/team-register");
              }}
            >
              조 임시 저장
            </button>
          </div>
        </div>

        <AddJoModal
          isOpen={isAddJoModalOpen}
          onClose={() => setIsAddJoModalOpen(false)}
          onAddTeams={handleAddTeams}
        />

        {isJoModalOpen && (
          <div className="jo-page" onClick={() => setIsJoModalOpen(false)}>
            <div className="group-organization-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-container">
                <div className="modal-content">
                  <h1 className="modal-title">조 편성</h1>
                  <div className="group-options-container">
                    <div className="group-options-grid">
                      {[1, 2, 3, 4].map((start) => (
                        <div className="column" key={start}>
                          {Array.from({ length: props.teams?.length || 28 }, (_, i) => i + 1)
                            .filter((n) => (n - start) % 4 === 0)
                            .map((n) => {
                              const current = props.teams?.find((t) =>
                                t.members.some((m) => m.member_id === joTargetMemberId)
                              );
                              const isSelected = current?.team_number === n;
                              return (
                                <button
                                  key={n}
                                  type="button"
                                  className={`group-option-button ${isSelected ? "selected" : ""}`}
                                  onClick={() => handleSelectTeamNumber(n)}
                                >
                                  <div className="group-option-content">
                                    <div className="check-circle-wrapper">
                                      <div className="check-circle-background"></div>
                                      <svg
                                        className="check-circle-icon"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                      >
                                        <path
                                          d="M6.81745 11.5447L12.42 5.94221L11.5418 5.06409L6.81745 9.78846L4.44245 7.41346L3.56433 8.29158L6.81745 11.5447ZM8.00162 15.9166C6.90662 15.9166 5.87738 15.7088 4.91391 15.2933C3.95044 14.8777 3.11238 14.3137 2.39975 13.6014C1.68711 12.889 1.12287 12.0513 0.707038 11.0883C0.291343 10.1252 0.0834961 9.09624 0.0834961 8.00138C0.0834961 6.90638 0.291274 5.87714 0.706829 4.91367C1.12238 3.9502 1.68634 3.11214 2.3987 2.3995C3.11107 1.68686 3.94877 1.12263 4.91183 0.706793C5.87489 0.291099 6.90384 0.083252 7.9987 0.083252C9.0937 0.083252 10.1229 0.291029 11.0864 0.706585C12.0499 1.12214 12.8879 1.6861 13.6006 2.39846C14.3132 3.11082 14.8775 3.94853 15.2933 4.91159C15.709 5.87464 15.9168 6.9036 15.9168 7.99846C15.9168 9.09346 15.7091 10.1227 15.2935 11.0862C14.8779 12.0496 14.314 12.8877 13.6016 13.6003C12.8893 14.313 12.0516 14.8772 11.0885 15.293C10.1254 15.7087 9.09648 15.9166 8.00162 15.9166ZM8.00016 14.6666C9.86127 14.6666 11.4377 14.0208 12.7293 12.7291C14.021 11.4374 14.6668 9.86103 14.6668 7.99992C14.6668 6.13881 14.021 4.56242 12.7293 3.27075C11.4377 1.97909 9.86127 1.33325 8.00016 1.33325C6.13905 1.33325 4.56266 1.97909 3.271 3.27075C1.97933 4.56242 1.3335 6.13881 1.3335 7.99992C1.3335 9.86103 1.97933 11.4374 3.271 12.7291C4.56266 14.0208 6.13905 14.6666 8.00016 14.6666Z"
                                          fill="#D1D5D8"
                                        />
                                      </svg>
                                    </div>
                                    <span className="group-number">{n}</span>
                                  </div>
                                </button>
                              );
                            })}
                        </div>
                      ))}
                    </div>
                    <div className="scroll-indicator">
                      <div className="scroll-bar"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </Fragment>
  );
}

const Container = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 12px;
  background: #fdfdfd;
  margin: 0 auto;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  height: 100vh; /* 전체 화면 높이 사용 */
  overflow: hidden; /* 글로벌 스크롤 제거 */

  /* Add Jo Modal Styles */
  .addjo-page {
    position: absolute;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;

    top: 0;
    left: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }

  .addjo-modal {
    display: flex;
    width: 100%;
    max-width: 700px;
    min-width: 330px;
    align-items: center;
    gap: 10px;
    border-radius: 6px;
    background: var(--teeshot-white, #fdfdfd);
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
    flex-direction: column;
  }

  .addjo-modal-container {
    padding: 24px;
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .addjo-modal-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  .addjo-modal-title {
    color: var(--teeshot-black, #1a1a1a);
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
  }

  .addjo-options-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .addjo-option-button {
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 6px;
    background: var(--teeshot-white, #fdfdfd);
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    padding: 0;
  }

  .addjo-option-button.default {
    border: 0.5px solid var(--teeshot-g2, #d1d5d8);
  }

  .addjo-option-button.active {
    border: 0.5px solid var(--teeshot-active, #007bff);
  }

  .addjo-option-content {
    display: flex;
    width: 100%;
    padding: 10px 8px;
    align-items: center;
    height: 40px;
    box-sizing: border-box;
  }

  .addjo-option-left {
    display: flex;
    align-items: center;
    gap: 6px;
    left: 8px;
    top: 10px;
    height: 20px;
  }

  .check-circle-wrapper {
    width: 20px;
    height: 20px;
    position: relative;
  }

  .check-circle-background {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    background: #d9d9d9;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 50%;
    opacity: 0;
  }

  .check-circle-icon {
    flex-shrink: 0;
    position: absolute;
    left: 2px;
    top: 2px;
    transition: fill 0.2s ease;
  }

  .check-circle-icon.active {
    left: 1px;
    top: 1px;
  }

  .addjo-option-text {
    color: var(--teeshot-black, #1a1a1a);
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-left: 6px;
  }

  .addjo-modal-buttons {
    display: flex;
    height: 60px;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    position: relative;
    margin-top: auto;
  }

  .addjo-cancel-button {
    display: flex;
    width: 100%;
    height: 60px;
    padding: 16px 46px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 0 0 0 6px;
    background: var(--teeshot-g1, #79818a);
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;
    color: var(--teeshot-white, #fdfdfd);
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
  }

  .addjo-cancel-button:hover {
    background: #6b7580;
  }

  .addjo-select-button {
    display: flex;
    width: 100%;
    height: 60px;
    padding: 16px 46px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 0 0 6px 0;
    background: var(--teeshot-green, #004b49);
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;
    color: var(--teeshot-white, #fdfdfd);
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
  }

  .addjo-select-button:hover {
    background: #003a38;
  }

  @media (max-width: 768px) {
    .addjo-page {
      padding: 20px;
    }

    .addjo-modal {
      width: 100%;
    }
  }

  /* Info Notice */
  .info-notice {
    display: flex;
    padding: 8px 12px;
    align-items: center;
    gap: 10px;
    border-radius: 6px;
    background: #dbedff;
    margin: 8px 0;
  }

  .notice-text {
    width: 100% !important;
    text-align: left !important;
    color: #007bff !important;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 150% !important;
    margin: 0 !important;
  }

  /* Round Date Section */
  .round-date-section {
    left: 16px;
    top: 102px;
  }

  .section-label {
    color: #1a1a1a;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    display: block;
    margin-bottom: 12px;
  }

  .date-selector {
    display: flex;
    height: 44px;
    padding: 12px 10px;
    justify-content: space-between;
    align-items: center;
    border-radius: 6px;
    border: 1px solid #d1d5d8;
    background: #fdfdfd;
    position: relative;
  }

  .selected-date {
    color: #1a1a1a;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .dropdown-arrow {
    width: 9px;
    height: 5px;
  }

  .section-divider {
    height: 1px;
    background: #d1d5d8;
    left: 16px;
    top: 192px;
  }

  /* Team Formation Section */
  .team-formation-section {
    left: 16px;
    top: 208px;
    flex: 1; /* 남은 공간을 모두 차지 */
    display: flex;
    flex-direction: column;
    min-height: 0; /* flex 아이템이 축소될 수 있도록 */
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
  }

  .section-title {
    color: #1a1a1a;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin: 0;
  }

  .member-count {
    color: #1a1a1a;
    text-align: right;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }

  .member-count strong {
    font-weight: 700;
  }

  .team-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1; /* 남은 공간을 모두 차지 */
    overflow-y: auto; /* 스크롤 가능 */
    padding-bottom: 120px; /* 하단 버튼 공간 확보 */
    min-height: 0; /* flex 아이템이 축소될 수 있도록 */
  }

  .team-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    border-radius: 6px;
    border: 1px solid #d1d5d8;
    background: #fdfdfd;
  }

  .team-content {
    height: 44px;
    align-self: stretch;
    position: relative;
  }

  .team-number {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    gap: 8px;
    height: 24px;
    z-index: 1;
  }

  .group-text {
    color: #007bff;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .expand-icon {
    width: 7px;
    height: 4px;
  }

  /* Team Selector Styles */
  .team-selector-wrapper {
    position: relative;
    z-index: 10;
  }

  .team-selector-wrapper > div {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
  }

  .team-selector-wrapper .popup-select-result {
    color: #007bff;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .member-info {
    display: flex;
    padding: 13px 16px 13px 76px;
    justify-content: space-between;
    align-items: center;
    height: 44px;
  }

  .member-role {
    color: #1a1a1a;
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    width: 25px;
  }

  .member-name {
    color: #1a1a1a;
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    width: 37px;
    min-width: 100px;
  }

  .member-phone {
    color: #79818a;
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    width: 107px;
  }

  .member-type {
    color: #79818a;
    text-align: right;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    width: 25px;
  }

  /* Action Buttons */
  .fixed-bottom-container {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding: 28px 16px;
    background: linear-gradient(0deg, #fdfdfd 76.92%, rgba(253, 253, 253, 0) 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
  }

  .action-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  .edit-button {
    display: flex;
    width: 175px;
    height: 60px;
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 10px;
    border: 1px solid #004b49;
    background: #fdfdfd;
    color: #004b49;
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    cursor: pointer;
  }

  .submit-button {
    display: flex;
    width: 175px;
    height: 60px;
    padding: 0 14px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 10px;
    background: #004b49;
    color: #fdfdfd;
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    border: none;
    cursor: pointer;
  }

  .submit-button:disabled {
    background: #d1d5d8;
    color: #79818a;
    cursor: not-allowed;
  }

  .cta-button {
    width: 100%;
    height: 60px;
    border: none;
    border-radius: 10px;
    background: #004b49;
    color: white;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  }

  .cta-button:hover {
    background: #003a38;
  }

  .cta-button:disabled {
    background: #d1d5d8;
    color: #79818a;
    cursor: not-allowed;
  }

  /* Jo Modal Styles */
  .jo-page {
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
  }
  .group-organization-modal {
    display: flex;
    width: 340px;
    padding: 24px 0;
    align-items: center;
    gap: 10px;
    border-radius: 6px;
    background: #fdfdfd;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
    height: 308px;
    position: relative;
  }
  .modal-container {
    display: flex;
    width: 340px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    flex-shrink: 0;
    position: relative;
  }
  .modal-content {
    display: flex;
    width: 290px;
    height: 260px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    position: relative;
  }
  .modal-title {
    align-self: stretch;
    color: #1a1a1a;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
  }
  .group-options-container {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    position: relative;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-right: 4px;
  }
  .group-options-grid {
    display: flex;
    gap: 8px;
    flex: 1;
  }
  .column {
    display: flex;
    width: 63px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    position: relative;
  }
  .group-option-button {
    display: flex;
    height: 40px;
    justify-content: flex-end;
    align-items: center;
    align-self: stretch;
    border-radius: 6px;
    border: 0.5px solid #d1d5d8;
    background: #fdfdfd;
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
    overflow: hidden;
  }
  .group-option-button:hover {
    background: #f8f9fa;
  }
  .group-option-button.selected {
    border-color: #007bff;
    background: #f0f8ff;
  }
  .group-option-content {
    display: flex;
    width: 290px;
    padding: 10px 8px;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    height: 40px;
    box-sizing: border-box;
  }
  .check-circle-background {
    width: 20px;
    height: 20px;
    background: #d9d9d9;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 50%;
    opacity: 0;
  }
  .check-circle-icon {
    width: 16px;
    height: 16px;
    fill: #d1d5d8;
    position: absolute;
    left: 2px;
    top: 2px;
    transition: fill 0.2s ease;
  }
  .group-number {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    position: absolute;
    left: 32px;
    min-width: 20px;
  }
  .scroll-indicator {
    width: 4px;
    height: 88px;
    border-radius: 100px;
    background: #79818a;
    position: relative;
    flex-shrink: 0;
  }
  .scroll-bar {
    width: 4px;
    height: 30px;
    border-radius: 100px;
    background: #79818a;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
